import React from "react";
import { TTableRow } from "./TableConst";
import TableRow, { TTableRowProps } from "./TableRow";
import { TTableCellProps } from "./TableCell";

export type TTableFooterProps<T extends TTableRow> = Omit<TTableRowProps<T>, "row"> & Omit<TTableCellProps<T>, "col"|"row"> & {
    footer:T[]
    rowKey:(row:T) => string|number
}

export default function TableFooter<T extends TTableRow>(props:TTableFooterProps<T>) {
    const rows = props.footer.map(row => <TableRow row={row} cols={props.cols} tr={props.tr} td={props.td} key={props.rowKey(row)} cellValue={props.cellValue} cellText={props.cellText}/>)
    return <tfoot>{rows}</tfoot>
}